import { useEffect } from "react";

export function useHotkey(
	key: string,
	callback: (event: KeyboardEvent) => void,
	options: {
		enabled?: boolean;
		ctrlOrCmd?: boolean;
		shift?: boolean;
		alt?: boolean;
	} = {},
) {
	const { enabled = true, ctrlOrCmd = false, shift = false, alt = false } = options;

	useEffect(() => {
		if (!enabled) {
			return () => {
				window.removeEventListener("keydown", handler);
			};
		}

		function handler(event: KeyboardEvent) {
			const isCorrectKey = event.key === key;
			const isCorrectCtrlOrCmd = ctrlOrCmd ? event.ctrlKey || event.metaKey : true;
			const isCorrectShift = shift ? event.shiftKey : true;
			const isCorrectAlt = alt ? event.altKey : true;

			if (isCorrectKey && isCorrectCtrlOrCmd && isCorrectShift && isCorrectAlt) {
				callback(event);
			}
		}

		window.addEventListener("keydown", handler);

		return () => {
			window.removeEventListener("keydown", handler);
		};
	}, [key, callback, enabled, ctrlOrCmd, shift, alt]);
}
